export const convertStringToNumber = (number) => {
  return Number(number.replace(".", "").replace(",", "."))
}
